<template>
  <LoadingContainer v-if="loading"/>

  <v-fade-transition v-else>
    <v-row class="ma-0" dense justify="center">
      <v-col cols="11" lg="10" xl="10">
        <v-row class="ma-0 pa-0" justify="center" dense>
          <TransactionDetailHeaderSection 
            @backToMenu="backToMenu" 
            :getTransactionData="getTransactionData"
            :transaction_content="transaction_content" 
            :transactionStatus="transactionStatus" 
          />
        </v-row>

        <v-row class="pa-0 pa-lg-6" dense>
          <v-col class="pr-lg-12" lg="9" cols="12">
            <TransactionDetailSummarySection 
              :transactionStatus="transactionStatus"
              :transaction_content="transaction_content" 
              :dayjs="dayjs" 
              :capitalize="capitalize"
              :transactionModel="transactionModel" 
              :filteredTransactionParameters="filteredTransactionParameters"
              :transaction_recipient_data="transaction_recipient_data"
            />

            <TransactionDetailIntervenersSection
              :key="transaction_content?.transaction_id"
              :transactionStatus="transactionStatus"
              :transaction_content="transaction_content"
              :capitalize="capitalize"
              :transactionModel="transactionModel"
              :faceToFaceQrLink="faceToFaceQrLink"
              :faceToFaceHideConfirm="faceToFaceHideConfirm"
              :getTransactionData="getTransactionData"
              :updateButtonLoading="updateButtonLoading"
            />

            <TransactionDetailEventsSection 
              :transactionStatus="transactionStatus"
              :transaction_content="transaction_content" 
              :checkPermission="checkPermission"
              :transaction_days="transaction_days" 
              :lastUpdate="lastUpdate" 
              :dayjs="dayjs" 
              :capitalize="capitalize"
              :const_permissions="const_permissions" 
            />

            <TransactionDetailUpdateSection 
              :transaction_content="transaction_content"
              :getTransactionData="getTransactionData" 
              :updateButtonLoading="updateButtonLoading"
              :const_permissions="const_permissions" 
              :checkPermission="checkPermission" 
              :lastUpdate="lastUpdate"
            />
          </v-col>

          <v-col cols="12" lg="3">
            <TransactionDetailActionsSection 
              :transactionStatus="transactionStatus"
              :transaction_content="transaction_content" 
              :getTransactionCertification="getTransactionCertification"
              :const_permissions="const_permissions"
              :checkPermission="checkPermission" 
              :availableCancel="availableCancel"
              :cancelTransaction="cancelTransaction" 
              :transactionModel="transactionModel" 
            />

            <TransactionDetailFilesSection 
              :transactionStatus="transactionStatus"
              :transaction_content="transaction_content"
              :documentsList="documentsList"
              :getTransactionCertification="getTransactionCertification"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-fade-transition>
</template>
<script>
import {
  NAMESPACE as TRANSACTIONS_NAMESPACE,
  STATE as TRANSACTIONS_STATE,
  ACTIONS as TRANSACTIONS_ACTIONS,
} from "@/constants/vuex/transactions";
import { formatFileNameForBack} from "@/plugins/helpers";
import { checkPermission } from "@/util/store_utils";
import const_global from "@/constants/global";
import const_permissions from "@/constants/permissions";
import const_icons from "@/constants/icons";
import dayjs from "@/plugins/dayjs";
import { getTransactionInfo,getTransactionCertification, cancelTransaction } from "@/services/transactionServices";
import { redirect } from "@/util/router_utils";
import { TRANSACTIONS } from "@/constants/router/routes";
import { capitalize, showToast } from "@/util/utils";
import { ServerBus } from "@/main";
import TransactionDetailHeaderSection from "@/components/sections/transactions/sections/TransactionDetailHeaderSection.vue";
import TransactionDetailSummarySection from "@/components/sections/transactions/sections/TransactionDetailSummarySection.vue";
import TransactionDetailIntervenersSection from "@/components/sections/transactions/sections/TransactionDetailIntervenersSection.vue";
import TransactionDetailEventsSection from "@/components/sections/transactions/sections/TransactionDetailEventsSection.vue";
import TransactionDetailActionsSection from "@/components/sections/transactions/sections/TransactionDetailActionsSection.vue";
import TransactionDetailUpdateSection from "@/components/sections/transactions/sections/TransactionDetailUpdateSection.vue";
import TransactionDetailFilesSection from "../sections/TransactionDetailFilesSection.vue";
import LoadingContainer from "@/components/structures/loadingContainer";

export default {
  name: "TransactionsViewStandard",
  components: {
    LoadingContainer,
    TransactionDetailHeaderSection,
    TransactionDetailSummarySection,
    TransactionDetailIntervenersSection,
    TransactionDetailEventsSection,
    TransactionDetailActionsSection,
    TransactionDetailUpdateSection,
    TransactionDetailFilesSection,
  },
  data() {
    return {
      const_icons,
      const_global,
      eventsInfoDialog: false,
      checkPermission,
      const_permissions,
      cancelDialog: false,
      loadingCancel: false,
      loading: false,
      // getTransactionData lo usa como estado de carga del botón de actualizar. Debe declararse
      // aquí para que sea reactivo: si no, los componentes que lo reciben como prop no ven el
      // paso a false y su botón se queda cargando indefinidamente.
      updateButtonLoading: false,
      lastUpdate: null,
      transaction_recipient_data: {},
      transaction_days: [],
    };
  },
   created() {
    this.$emit("loadingState", false);
    this.getTransactionData(true);
    ServerBus.$on("closeModal", () => {
      this.handleClickModalDocument();
    });
  },
  computed: {
    behaviourLayer() {
      try {
        return JSON.parse(this.transaction_content?.behavior_layer);
      } catch {
        return {};
      }
    },
    transactionModel() {
      if (this.behaviourLayer && this.behaviourLayer.steps && this.behaviourLayer.steps[0] && this.behaviourLayer.steps[0].model) {
        return this.behaviourLayer.steps[0].model;
      }
      return "standard";
    },
    faceToFaceQrLink() {
      return !!this.behaviourLayer?.transactionDetailView?.faceToFaceQrLink;
    },
    faceToFaceHideConfirm() {
      return !!this.behaviourLayer?.transactionDetailView?.faceToFaceHideConfirm;
    },
    transaction_content() {
      let tc = this.$store.state[TRANSACTIONS_NAMESPACE][TRANSACTIONS_STATE.S_TRANSACTION];
      if (tc) {
        if (Object.prototype.hasOwnProperty.call(tc, const_global.EVENTS)) {
          this.formatEvents(tc);
        }
        this.formatRecipientData(tc);
      }
      if (tc != null && tc.parameters != null && tc.parameters["_COST_CENTER_"] != null) {
        delete tc.parameters["_COST_CENTER_"];
      }
      if (tc && tc.interveners && tc.interveners.length > 0 && Array.isArray(tc.events)) {
        tc.interveners.forEach((intervener) => {
          tc.events
            .filter((event) => {
              return event.key.indexOf("front_renderer_builder") !== -1;
            })
            .forEach((event) => {
              if (event.subtitle.includes(intervener.client_id)) {
                event.intervener = intervener.client_id;
              }
            });
        });
      }
      return tc;
    },
    documentsList() {
      const docList = [];

      if (this.transaction_content?.files == null) {
        return docList;
      }
      const transactionParameters = Object.values(this.transaction_content?.files);
      transactionParameters.forEach((element) => {
        if (Array.isArray(element)) {
          element.forEach((value) => {
            if (this.isDocument(value)) {
              const documentType = value.substring(value.lastIndexOf(".") + 1);
              docList.push({
                key: value,
                type: documentType,
              });
            }
          });
        } else if (this.isDocument(element)) {
          const documentType = element.substring(element.lastIndexOf(".") + 1);

          docList.push({
            key: element,
            type: documentType,
          });
        }
      });
      return docList;
    },
    availableCancel() {
      if (!checkPermission(const_permissions.SECTION_PROCESS) || this.transactionStatus.id !== "pending") {
        return false;
      }
      return !this.transaction_content?.events.find((i) => i.key === "TRANSACTION.canceled");
    },
    transactionStatus() {
      let status = {
        id: "pending",
        icon: const_icons.WAITING,
        color: "var(--warning)",
        text: this.$vuetify.lang.t("$vuetify.transactionPending"),
      };

      const intromissionCanceled = this.transaction_content?.intromissions.find(
        (i) => formatFileNameForBack(i.action).replace(" ", "_").toLowerCase() === "transaccion_cancelada"
      );

      const transactionIsCancelled = this.transaction_content?.events
        .find((i) => i.key === "TRANSACTION.canceled") !== undefined;


      if (
        this.transaction_content &&
        (this.transaction_content?.terminal == 1 ||
          (this.transaction_content?.certification !== "0" && this.transaction_content?.certification !== "")
        )
      ) {
        status.id = "finished";
        status.icon = const_icons.CHECK_CIRCLE;
        status.color = "var(--success)";
        status.text = this.$vuetify.lang.t("$vuetify.finished");
      }
      if (this.containErrorEvent()) {
        status.id = "alert";
        status.icon = const_icons.ALERT;
        status.color = "var(--warning)";
        status.text = this.$vuetify.lang.t("$vuetify.transactionWarning");
      }
      if (this.transaction_content?.transaction_id.indexOf("INVALID") !== -1) {
        status.id = "invalid";
        status.icon = const_icons.ERROR;
        status.color = "var(--error)";
        status.text = this.$vuetify.lang.t("$vuetify.notValid");
      }
      if (intromissionCanceled || transactionIsCancelled) {
        status.id = "cancelled";
        status.icon = const_icons.CANCEL;
        status.color = "var(--error)";
        status.text = this.$vuetify.lang.t("$vuetify.cancelled");
      }
      return status;
    },
    filteredTransactionParameters() {
      let behaviourLayer;
      try {
        behaviourLayer = JSON.parse(this.transaction_content?.behavior_layer);
      } catch {
        behaviourLayer = null;
      }
      const hiddenParameters = behaviourLayer?.transactionDetailView?.hiddenParameters || [];
      return this.transaction_content?.parameters
        ? this.transaction_content?.parameters.filter((x) => !hiddenParameters.includes(x.key))
        : [];
    },
  },
  methods: {
    capitalize,
    getTransactionCertification,
    async getTransactionData(loading = false) {
      this.updateButtonLoading = true;
      this.loading = loading;
      await getTransactionInfo().then((response) => {
        this.$store.dispatch(`${TRANSACTIONS_NAMESPACE}/${TRANSACTIONS_ACTIONS.A_SET_TRANSACTION}`, response.data);
        setTimeout(() => {
          this.loading = false;
          this.updateButtonLoading = false;
        }, 500);
      });
      this.lastUpdate = dayjs();
    },
    cancelTransaction() {
      this.loadingCancel = true;
      cancelTransaction(this.transaction_content?.transaction_id).then((response) => {
        setTimeout(() => {
          showToast(response.data.error !== 0, this.$vuetify.lang.t(`$vuetify.${response.data.message}`));
          this.loadingCancel = false;
          this.cancelDialog = false;
          this.getTransactionData(true);
        }, 1500);
      });
    },
    handleClickModalDocument() {
      this.showDocumentViewer = false;
      this.isBtnDisabled = false;
    },
    parseBehaviourLayer(behaviourLayer) {
      try {
        return JSON.parse(behaviourLayer);
      } catch {
        return null;
      }
    },
    isDocument(value) {
      return typeof value == "string" && value !== "";
    },
    formatEvents(tc) {
      let arr_aux = [];
      let dates = [];

      if (tc.events !== null && typeof tc.events !== "undefined") {
        tc.events.forEach((event) => {
          if (event.event !== "Instance_Delete") {
            if (event.event_at != null) {
              dates.push(event.event_at);
            }

            let day = {};
            const day_name = dayjs.unix(event.event_at).format(const_global.DATE_TIME_FORMAT_B);

            if (arr_aux.find((d) => d.day_name === day_name) === undefined) {
              day["day_name"] = day_name;
              day["day_at"] = event.event_at;
              day["order"] = event.order;
              day["events"] = [];
              arr_aux.push(day);
            }
            arr_aux.find((d) => d.day_name === day_name)["events"].push(event);
          }
        });
        const bl = this.parseBehaviourLayer(tc.behavior_layer);
        let model = "standard";
        if (bl && bl.steps && bl.steps[0] && bl.steps[0].model) {
          model = bl.steps[0].model;
        }

        if (model === "digital_signature") {
          arr_aux.forEach((day) => {
            day.events.sort((a, b) => {
              if (a.event_at === b.event_at) {
                return a.order - b.order;
              }
              return a.event_at - b.event_at;
            });
          });
          dates.sort((a, b) => {
            return a - b;
          });

          arr_aux.sort((a, b) => {
            return a.day_at - b.day_at;
          });
        } else {
          arr_aux.forEach((day) => {
            day.events.sort((a, b) => {
              if (a.event_at === b.event_at) {
                return b.order - a.order;
              }
              return b.event_at - a.event_at;
            });
          });
          dates.sort((a, b) => {
            return b - a;
          });

          arr_aux.sort((a, b) => {
            return b.day_at - a.day_at;
          });
        }
        this.transaction_days = arr_aux;
      }
    },
    formatRecipientData(tc) {
      if (tc && tc.recipient_data) {
        Object.entries(tc.recipient_data).forEach(([key, value]) => {
          if (key !== const_global.CONTACT_COUNTRY_CODE) {
            this.transaction_recipient_data[key] =
              key === const_global.CONTACT_PHONE && value ? `+${tc.recipient_data[const_global.CONTACT_COUNTRY_CODE]} ${value}` : value;
          }
        });
      } else {
        this.transaction_recipient_data = {};
      }
    },
    backToMenu() {
      redirect(TRANSACTIONS);
    },
    containErrorEvent() {
      const errorEvents = ["front_renderer_builder.transaction_invalid"];
      return this.transaction_content?.events?.some((event) => errorEvents.includes(event.key));
    },

  },
  filters: {
    capitalize,
  },
  watch: {
    'transaction_content.transaction_id'(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.getTransactionData(true);
      }
    }
  },
  beforeDestroy() {
    ServerBus.$off("closeModal");
  },
}
</script>